import { TabSelect, Divider } from 'mondrian-react';
import styles from './styles.module.css';

function Tabelas({ result }) {
  return (
    <TabSelect
      data={[
        {
          title: 'Descrição',
          content: (
            <>
              <Divider className={styles.Divider} />
              <div
                className={`mdn-ProductDetailsHorizontal ${styles.ContainerTable}`}
              >
                <table>
                  <tbody>
                    <tr>
                      <td>Camada de Exposição</td>
                      <td>{result?._source?.layer}</td>
                    </tr>
                    <tr>
                      <td>Nome do Serviço</td>
                      <td>{result?._source?.servico}</td>
                    </tr>
                    <tr>
                      <td>Descrição do Serviço</td>
                      <td>{result?._source?.servico_descr}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ),
        },
        {
          title: 'Operações',
          content: (
            <>
              <Divider className={styles.Divider} />
              <div
                className={`mdn-ProductDetailsHorizontal ${styles.ContainerTableColunas}`}
              >
                <table>
                  <tbody>
                    <tr>
                      <th>Operações</th>
                      <th>Descrição da Operação</th>
                    </tr>
                    {result?._source?.operacoes?.map((item, i) => {
                      return [
                        <tr key={i}>
                          <td>{item.operacao}</td>
                          <td>{item.operacao_descr}</td>
                        </tr>,
                      ];
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ),
        },
      ]}
    />
  );
}

export default Tabelas;
